export default "__VITE_ASSET__DnRX_w3u__"